import { tenantPath } from "helpers/tenant_path";
import { getHeaders } from "packs/client_app/config/request_headers";

import { FeedbackParams } from "@/client_app/features/timesheetApproval/components/FeedbackItem";

export const sendRatingFeedBack = ({
  positionId,
  categories,
  isLiked,
  review,
  rehire,
}: FeedbackParams) => {
  return fetch(tenantPath("/weployer/api/rating_feedbacks"), {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({
      position_id: positionId,
      categories: categories,
      is_liked: isLiked,
      review: review,
      rehire,
    }),
  });
};
